var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "insta-feed" },
    [
      _c(
        "div",
        { staticClass: "row" },
        _vm._l(_vm.feeds, function(f, index) {
          return _c(
            "div",
            { key: f.id, staticClass: "col-12 col-sm-3 col-md-4" },
            [
              f.mediaType == "VIDEO"
                ? [
                    _c("div", { staticClass: "card-photos card-video" }, [
                      _c("div", { staticClass: "img-holder" }, [
                        _c("i", {
                          staticClass: "ri-live-fill icon-insta-type"
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            attrs: { href: "" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.showFeedItemDetail(index)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "img-fluid",
                              staticStyle: { width: "100%" },
                              attrs: { src: f.thumbnail || f.mediaUrl }
                            })
                          ]
                        )
                      ])
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              f.mediaType == "IMAGE"
                ? [
                    _c("div", { staticClass: "card-photos card-image" }, [
                      _c("div", { staticClass: "img-holder" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.showFeedItemDetail(index)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "img-fluid",
                              staticStyle: { width: "100%" },
                              attrs: { src: f.thumbnail || f.mediaUrl }
                            })
                          ]
                        )
                      ])
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              f.mediaType == "CAROUSEL_ALBUM"
                ? [
                    _c("div", { staticClass: "card-photos card-carousel" }, [
                      _c("div", { staticClass: "img-holder" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "icon-insta-type",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 24 24",
                              width: "24",
                              height: "24"
                            }
                          },
                          [
                            _c("path", {
                              attrs: { fill: "none", d: "M0 0h24v24H0z" }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M20.083 10.5l1.202.721a.5.5 0 0 1 0 .858L12 17.65l-9.285-5.571a.5.5 0 0 1 0-.858l1.202-.721L12 15.35l8.083-4.85zm0 4.7l1.202.721a.5.5 0 0 1 0 .858l-8.77 5.262a1 1 0 0 1-1.03 0l-8.77-5.262a.5.5 0 0 1 0-.858l1.202-.721L12 20.05l8.083-4.85zM12.514 1.309l8.771 5.262a.5.5 0 0 1 0 .858L12 13 2.715 7.429a.5.5 0 0 1 0-.858l8.77-5.262a1 1 0 0 1 1.03 0z",
                                fill: "rgba(255,255,255,1)"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            attrs: { href: "" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.showFeedItemDetail(index)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "img-responsive",
                              staticStyle: { width: "100%" },
                              attrs: { src: f.thumbnail || f.mediaUrl }
                            })
                          ]
                        )
                      ])
                    ])
                  ]
                : _vm._e()
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" }),
      _vm._v(" "),
      _vm.showLoadMore && !_vm.loadingFeeds
        ? _c(
            "a",
            {
              staticClass:
                "btn btn-primary btn-donate-lg shadow-sm  btn-lg text-uppercase fw-bold rounded-4 rounded px-5 py-3 fs-5 d-table m-auto",
              attrs: { href: "", id: "loadMore" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.loadMore.apply(null, arguments)
                }
              }
            },
            [_vm._v("VIEW MORE")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loadingFeeds
        ? _c("div", [
            _c("p", { staticClass: "lead text-info text-center" }, [
              _vm._v("Loading...")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("insta-feed-detail-modal", {
        attrs: {
          show: _vm.showFeedDetail,
          feeds: _vm.feeds,
          "selected-feed-item-index": _vm.selectedFeedItemIndex
        },
        on: {
          "update:show": function($event) {
            _vm.showFeedDetail = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }